export const portrait = window.matchMedia('(orientation: portrait)');
